/**
 * Index des aventures disponibles
 */

import type { GameConfig } from '@hollowveil/shared';
import { demoConfig } from '../demoConfig';
import { reveilEducatriceConfig } from './reveilEducatrice';

export interface AdventureInfo {
  id: string;
  config: GameConfig;
  name: string;
  description: string;
  icon: string;
  isNew?: boolean;
}

/**
 * Liste des aventures disponibles
 */
export const adventures: AdventureInfo[] = [
  {
    id: 'reveil_educatrice',
    config: reveilEducatriceConfig,
    name: 'Le (R)éveil de l\'Éducatrice',
    description: 'Aide des âmes en détresse à travers 5 mondes. Une aventure sur l\'écoute et la compréhension.',
    icon: '💜',
    isNew: true,
  },
  {
    id: 'classic_adventure',
    config: demoConfig,
    name: 'Aventure Classique',
    description: 'L\'aventure originale de Hollowveil. Explore les deux mondes et résous les mystères.',
    icon: '👻',
    isNew: false,
  },
];

/**
 * Obtenir une aventure par son ID
 */
export function getAdventureById(id: string): AdventureInfo | undefined {
  return adventures.find(a => a.id === id);
}

/**
 * L'aventure par défaut (la nouvelle)
 */
export const defaultAdventure = adventures[0];
